import { render } from "./MainSystemEspecificAcess.vue?vue&type=template&id=e7c16208&scoped=true"
import script from "./MainSystemEspecificAcess.vue?vue&type=script&lang=js"
export * from "./MainSystemEspecificAcess.vue?vue&type=script&lang=js"

import "./MainSystemEspecificAcess.vue?vue&type=style&index=0&id=e7c16208&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7c16208"]])

export default __exports__